module.exports = __webpack_public_path__ + "static/media/jennifer.f455f21f.jpeg";